export default __webpack_public_path__ + "static/media/satellite.c49de362.svg";